<template>
  <v-application>
    <v-layout row class="ma-2">
      <v-flex>
        <v-crud-card
          name="tech_map"
          v-bind:headers="headers"
          v-bind:data="tech_maps"
          v-bind:add_button_name="'add_tech_map'"
          :data_loading="loading_tech_map"
          @change-pagination="changePagination"
          v-bind:saveDisabled="saveDisabled"
          v-model="page"
          v-bind:num-pages="num_pages"
          v-bind:remove="remove"
          to="/items/tech-map/detail"
        >
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>

<script>
import TechMap from "../../mixins/items/tech_map";

export default {
  data: () => ({
    headers: [],
    loading_tech_map: false,
    num_pages: 1
  }),
  mixins: [TechMap],
  computed: {
    saveDisabled() {
      return false;
    }
  },
  watch: {
    page() {
      this.update();
    }
  },
  beforeMount() {
    this.headers = [
      { text: this.$t("product_name"), value: "product_name", sortable: false, available: true }
    ];
  },
  methods: {
    changePagination(page) {
      this.page = page;
    },
    async remove(items) {
      const indexes = [];
      for (const it of items) {
        indexes.push(it._id);
      }
      this.$communicator.then(
        this,
        await this.$communicator("tech_map_delete", {
          params: {
            indexes
          }
        })
      );
      this.update();
    },
    update() {
      this.getTechMap();
    }
  },
  mounted() {
    this.update();
  }
};
</script>
